import { render, staticRenderFns } from "./ModuleBhcpfPageSrp.vue?vue&type=template&id=d007b712&"
import script from "./ModuleBhcpfPageSrp.vue?vue&type=script&lang=js&"
export * from "./ModuleBhcpfPageSrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports